module.exports = {"login_title":"تسجيل الدخول ","login_signin":"تسجيل الدخول","login_register":"اشترك","track_your_order":"أتبع طلبك ","validate_num":"","validate_email":"عنوان البريد الإلكتروني: (مطلوب.","validate_invalid_email":"صالح عنوان البريد الإلكتروني مطلوب.","validate_name":"الاسم الأول مطلوب","validate_phone":"الهاتف مطلوب.","validate_invalid_phone":"يجب أن يكون خط العرض الصحيح بين 6 و 11 حرفًا.","validate_term":"يرجى الموافقة على شروط الاستخدام وسياسة الخصوصية قبل المتابعة."}


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/ae.json
// module id = ddZc
// module chunks = 56